import {
  LibraryAddModeDialog,
  type LibraryAddMode,
} from "@/action-dialog/dialogs/LibraryAddModeDialog";
import { setAlwaysAddAsReference } from "@/action-dialog/libraryAddModePreference";
import { createCallable } from "react-call";

const UNMOUNTING_DELAY_MS = 200;

export type LibraryAddModeCallableProps = {
  count: number;
  /** Shown when count === 1. */
  fileName?: string;
  destination: "canvas" | "chat";
};

/** Resolves with the chosen mode, or null when dismissed. */
export const LibraryAddModeCallable = createCallable<
  LibraryAddModeCallableProps,
  LibraryAddMode | null
>(
  ({ call, count, fileName, destination }) => (
    <LibraryAddModeDialog
      count={count}
      fileName={fileName}
      destination={destination}
      onChoose={(choice, { alwaysReference }) => {
        // Persist on confirm (either verb — the preference governs the
        // NEXT pick), never on dismiss.
        if (alwaysReference) setAlwaysAddAsReference();
        call.end(choice);
      }}
      onClose={() => call.end(null)}
    />
  ),
  UNMOUNTING_DELAY_MS,
);

LibraryAddModeCallable.displayName = "LibraryAddModeCallable";
